export default __webpack_public_path__ + "static/media/sfondoroadmap.9e2c3e3d.png";